import React, { Component } from 'react';
import {
  GanttComponent,
  EditDialogFieldsDirective,
  DayMarkers,
  EditDialogFieldDirective,
  Inject,
  Edit,
  Selection,
  Toolbar,
  ColumnsDirective,
  ColumnDirective,
  CriticalPath,
  ContextMenu,
  Reorder,
  Resize,
  VirtualScroll,
  Filter,
  IGanttData,
  ColumnMenu,
  PdfExport,
  Sort,
  ExcelExport,
  FilterType,
  QueryCellInfoEventArgs,
  TimelineSettingsModel,
} from '@syncfusion/ej2-react-gantt';
import { GetBackendUrlForGlobalFunctions } from '../../App';
import {
  CheckBoxSelection,
  DropDownListComponent,
  MultiSelectComponent,
  Inject as DDInject,
} from '@syncfusion/ej2-react-dropdowns';
import { all_information, loadingShow } from '../../App';
import Message from '../../utils/Message/Message';
import moment from 'moment';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import {
  ColumnChooser,
  FilterSettingsModel,
  ContextMenuItemModel,
} from '@syncfusion/ej2-react-grids';
import Load from './Load';
import { ThemeContext } from '../../context/theme.context';
import { SidebarComponent } from '@syncfusion/ej2-react-navigations';
import { BsChevronCompactLeft, BsChevronCompactRight } from 'react-icons/bs';
import {
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import {
  NumericTextBoxComponent,
  TextBoxComponent,
} from '@syncfusion/ej2-react-inputs';
import {
  ChipDirective,
  ChipListComponent,
  ChipsDirective,
} from '@syncfusion/ej2-react-buttons';
import { FcSettings } from 'react-icons/fc';
import { AiFillLock, AiFillUnlock, AiOutlineFilter } from 'react-icons/ai';
import {
  DateRangePickerComponent,
  DateTimePickerComponent,
} from '@syncfusion/ej2-react-calendars';
import {
  GetPlanOrderGant,
  GetSchedulerKPI,
  EditGanttSettings,
  GetGanttSettings,
} from '../../services/CloudScheduler/CloudSchedulerServices';
import {
  EditGantt,
  EditOperations,
} from '../../services/Operations/OperationServices';
import { EditPlan, getPlan } from '../../services/ControlCenter/PlanServices';
import axios from 'axios';
import { getEvents } from '../../services/events/event';
import { getTrades } from '../../services/tradeperson/trades';
import { columns, editDialogFields } from './columns';
import { ListViewComponent } from '@syncfusion/ej2-react-lists';
import GlobalPlannedOrderGrid from '../../components/GlobalPlannedOrderGrid';
import {
  GetGanttDataByPlan,
  SavePointOfTheGantt,
  SendRequest,
} from '../../utils/CreateRequest';
import { GetRosters } from '../../services/Settings/Roster';
import { arrayPreparing, generateSegmentation } from '../../utils/GanttHelper';
import { addToQuery, applyTheRule } from '../../utils/BussinesRuleBuilder';
import SidebarKPI from './SidebarKPI';
import GanttSettings from './GanttSettings';
import GlobalDialog from '../../components/GlobalDialog';
import {
  GlobalDropDown,
  GlobalMultiSelection,
} from '../../components/GlobalDropDown';
import { useDispatch } from 'react-redux';
import { setIsPlanSelected } from '../../redux/search.slice';
interface IProps {
  isSuperVisor?: boolean;
  toolbar?: any;
  dispatch?: any;
}
interface IState {
  eventsData: any;
  GantData: any;
  resourceData: any;
  currentIcon: any;
  status: boolean;
  loadGant: Array<any>;
  planData: Array<any>;
  projectStartDate: Date;
  projectEndDate: Date;
  isSidebarOpen: boolean;
  hideDeleteDialog: boolean;
  hideAssignTeamDialog: boolean;
  hidePercentage: boolean;
  hideSchedulerTimeDialog: boolean;
  settingsDialog: boolean;
  ShiftElementData: Array<any>;
  hideFilterDialog: boolean;
  trades_data: Array<any>;
  tradesValues: any;
  expandableButton: boolean;
  allowRender: boolean;
  queryForLoad: string;
  dayWorkingTime: Array<any>;
  current_plan_isLocked: boolean;
  currentDialogSettings: {
    width: string | undefined;
    height: string | undefined;
    firstButtonText: string | undefined;
    seccondButtonText: string | undefined;
    type: string | undefined;
    content: any | undefined;
    show: boolean | undefined;
  };
  maxSchedulerPeriod: number;
  hideGant: boolean;
  hideDialogOrder: boolean;
  allowDragDrop: boolean;
  allowSeg: boolean;
  query: string;
  refreshToken: string;
  teamIds: Array<number>;
}
// const [eventsData, setEventsData] = useState<any>(null);
//   const [GantData, setGantData] = useState<any>(null);
//   const [resourceData, setResourceData] = useState<any>(null);
//   const [currentIcon, setCurrentIcon] = useState<any>(null);
//   const [status, setStatus] = useState<boolean>(false);
//   const [loadGant, setLoadGant] = useState<Array<any>>([]);
//   const [planData, setPlanData] = useState<Array<any>>([]);
//   const [projectStartDate, setProjectStartDate] = useState<Date>(new Date());
//   const [projectEndDate, setProjectEndDate] = useState<Date>(new Date());
//   const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
//   const [hideDeleteDialog, setHideDeleteDialog] = useState<boolean>(false);
//   const [hidePercentage, setHidePercentage] = useState<boolean>(false);
//   const [hideSchedulerTimeDialog, setHideSchedulerTimeDialog] = useState<boolean>(false);
//   const [settingsDialog, setSettingsDialog] = useState<boolean>(false);
//   const [ShiftElementData, setShiftElementData] = useState<Array<any>>([]);
//   const [graphDataSet, setGraphDataSet] = useState<any>(null);
//   const [hideFilterDialog, setHideFilterDialog] = useState<boolean>(false);
//   const [trades_data, setTradesData] = useState<Array<any>>([]);
//   const [tradesValues, setTradesValues] = useState<any>(null);
//   const [expandableButton, setExpandableButton] = useState<boolean>(false);
//   const [allowRender, setAllowRender] = useState<boolean>(false);
//   const [queryForLoad, setQueryForLoad] = useState<string>("'8/1/2022 8:00:00'$'8/31/2022 8:00:00'$33$'8:00:00'");
//   const [dayWorkingTime, setDayWorkingTime] = useState<Array<any>>([]);
//   const [current_plan_isLocked, setCurrentPlanIsLocked] = useState<boolean>(false);
//   const [currentDialogSettings, setCurrentDialogSettings] = useState<{
//     width: string | undefined;
//     height: string | undefined;
//     firstButtonText: string | undefined;
//     seccondButtonText: string | undefined;
//     type: string | undefined;
//     content: any | undefined;
//     show: boolean | undefined;
//   }>({
//     width: undefined,
//     height: undefined,
//     firstButtonText: undefined,
//     seccondButtonText: undefined,
//     type: undefined,
//     content: undefined,
//     show: undefined,
//   });
//   const [maxSchedulerPeriod, setMaxSchedulerPeriod] = useState<number>(0);
//   const [hideGant, setHideGant] = useState<boolean>(false);
//   const [hideDialogOrder, setHideDialogOrder] = useState<boolean>(false);
//   const [allowDragDrop, setAllowDragDrop] = useState<boolean>(false);
//   const [allowSeg, setAllowSeg] = useState<boolean>(false);

export class CloudScheduler extends Component<IProps, IState> {
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private ganttDatas: any;
  private allowEdit: boolean = false;
  private editSettings: object = {
    allowAdding: true,
    allowEditing: true,
    allowDeleting: true,
    allowTaskbarEditing: true,
    showDeleteConfirmDialog: true,
  };
  private toolbarAdmin = [
    {
      text: 'Assign Workorders',
      tooltipText: 'Assign workorders into the plan.',
      prefixIcon: 'e-properties-1',
      id: 'assign_workorders',
    },
    {
      text: 'Send Back',
      tooltipText: '.',
      prefixIcon: 'e-send-to-back',
      id: 'reject',
    },
    {
      text: 'Previous Day',
      tooltipText: 'Rescheduled it for one day.',
      prefixIcon: 'e-chevron-left',
      id: 'previous',
    },
    {
      text: 'Next Day',
      tooltipText: 'Rescheduled it for one day.',
      prefixIcon: 'e-chevron-right',
      id: 'next',
    },
    {
      text: 'Show History',
      tooltipText: 'Show history of the record.',
      prefixIcon: 'e-notes',
      id: 'history',
    },
    'Edit',
    'Update',
    {
      text: 'Assign Shift',
      tooltipText: 'Assign Shift',
      prefixIcon: 'e-edit',
      id: 'assignshift',
    },
    {
      text: 'Assign Team',
      tooltipText: 'Assign Team',
      prefixIcon: 'e-edit',
      id: 'assignteam',
    },
    {
      text: 'Percentage',
      tooltipText: 'To set percentage on a record',
      prefixIcon: 'e-edit',
      id: 'percentage',
    },
    {
      text: 'Schedule',
      tooltipText: 'Scheduler',
      prefixIcon: 'e-timeline-month',
      id: 'scheduler',
    },
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-repeat',
      id: 'refresh',
    },
    'Cancel',
    'ExpandAll',
    'CollapseAll',
    'Indent',
    'Outdent',
    'Search',
    'PrevTimeSpan',
    'NextTimeSpan',
    'Outdent',
    'Indent',
    'ZoomIn',
    'ZoomOut',
    'ZoomToFit',
    'CsvExport',
    'PdfExport',
    'ExcelExport',
    'CriticalPath',
  ];
  private assignTeamDropDown: DropDownListComponent = new DropDownListComponent(
    {}
  );
  private assignTeamText: string = '';

  private teamFMSCom: MultiSelectComponent = new MultiSelectComponent({});
  private teamFMSComValue: Array<any> = [];
  private shiftFMSCom: MultiSelectComponent = new MultiSelectComponent({});
  private shiftFMSComValue: Array<any> = [];
  private teamsLocalVal = localStorage.getItem('teams');
  private teamsLocalText = localStorage.getItem('teams_text');
  private shiftsLocalVal = localStorage.getItem('shifts');
  private shiftsLocalText = localStorage.getItem('shifts_text');
  private teamValues: Array<any> =
    this.teamsLocalVal === null
      ? []
      : [...this.teamsLocalVal.split(',').map((el) => Number(el))];
  private shiftValues: Array<any> = [];
  // private shiftValues: Array<any> =
  //   this.shiftsLocalVal === null
  //     ? []
  //     : [...this.shiftsLocalVal.split(',').map((el) => Number(el))];
  private condition: boolean = true;
  private dropDown: DropDownListComponent;
  private tradesLocalVal = localStorage.getItem('trades');
  private tradesLocalText = localStorage.getItem('trades_text');
  private tradeValues: Array<any> =
    this.tradesLocalVal === null
      ? []
      : [...this.tradesLocalVal.split(',').map((el) => Number(el))];
  private tradeTexts: Array<any> =
    this.tradesLocalText === null
      ? []
      : [...this.tradesLocalText.split(',').map((el) => el)];

  private teamTexts: Array<any> =
    this.teamsLocalText === null
      ? []
      : [...this.teamsLocalText.split(',').map((el) => el)];
  private batch_obj: Array<any> = [];
  public static start_date: Date =
    localStorage.getItem('load_start_date') !== null
      ? new Date(localStorage.getItem('load_start_date') as string)
      : new Date();
  public static queryForLoad: string =
    "'8/1/2022 8:00:00'$'8/31/2022 8:00:00'$33$'8:00:00'";
  public static isDateChangeRequest: boolean = false;
  private fieldEvent: object = {
    text: 'eventCode',
    value: 'eventId',
  };
  private fieldPlan: object = {
    text: 'plan_name',
    value: 'ID',
  };
  public editDialogFields: any = [
    { type: 'General' },
    { type: 'Predecessor' },
    { type: 'Resources' },
    { type: 'Notes' },
    {
      type: 'Custom',
      headerText: 'Extra Tab',
      fields: ['ExtraCol1', 'ExtraCol2'],
    },
  ];
  private current_data: Array<any> = [];
  private percentage: NumericTextBoxComponent = new NumericTextBoxComponent({});
  private isMountedCS: boolean = false;
  private reasonCodes: DropDownListComponent = new DropDownListComponent({});
  private percentageNumber: NumericTextBoxComponent =
    new NumericTextBoxComponent({});
  private reasonDesc: any = new TextBoxComponent({});
  private dateRangeValue: Date[] = [
    new Date(),
    new Date(new Date().setDate(new Date().getDate() + 7)),
  ];
  private offset = localStorage.getItem('offsetValue');
  temp = (props: any) => {
    return (
      <NumericTextBoxComponent
        width={120}
        value={this.offset ? parseInt(this.offset) : 1}
        min={1}
        max={365}
        step={1}
        onChange={(args: any) => {
          console.log('args: ', args);
          this.offset = args.value;
          localStorage.setItem('offsetValue', `${args.value}`);
        }}
        //placeholder='Percentage format'
        floatLabelType='Auto'
      />
    );
  };
  private toolbar = [
    {
      text: 'Assign Workorders',
      tooltipText: 'Assign workorders into the plan.',
      prefixIcon: 'e-properties-1',
      id: 'assign_workorders',
    },
    {
      text: 'Previous Day',
      tooltipText: 'Rescheduled it for one day.',
      prefixIcon: 'e-chevron-left',
      id: 'previous',
    },
    {
      text: 'Day',
      tooltipText: 'Set Offset.',
      id: 'a',
      width: 30,
      template: this.temp,
    },
    {
      text: 'Next Day',
      tooltipText: 'Rescheduled it for one day.',
      prefixIcon: 'e-chevron-right',
      id: 'next',
    },
    {
      text: 'Show History',
      tooltipText: 'Show history of the record.',
      prefixIcon: 'e-notes',
      id: 'history',
    },

    'Edit',
    'Update',
    {
      text: 'Assign Shift',
      tooltipText: 'Assign Shift',
      prefixIcon: 'e-edit',
      id: 'assignshift',
    },
    {
      text: 'Assign Team',
      tooltipText: 'Assign Team',
      prefixIcon: 'e-edit',
      id: 'assignteam',
    },
    {
      text: 'Percentage',
      tooltipText: 'To set percentage on a record',
      prefixIcon: 'e-edit',
      id: 'percentage',
    },
    {
      text: 'Schedule',
      tooltipText: 'Scheduler',
      prefixIcon: 'e-timeline-month',
      id: 'scheduler',
    },
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-repeat',
      id: 'refresh',
    },
    'Cancel',
    'ExpandAll',
    'CollapseAll',
    'Indent',
    'Outdent',
    'Search',
    'PrevTimeSpan',
    'NextTimeSpan',
    'Outdent',
    'Indent',
    'ZoomIn',
    'ZoomOut',
    'ZoomToFit',
    'CsvExport',
    'PdfExport',
    'ExcelExport',
    'CriticalPath',
    {
      text: 'Commit',
      tooltipText: 'Commit to Pronto Database',
      prefixIcon: 'e-check',
      id: 'commit',
    },
  ];
  private current_query: string = '';
  private theQueryPlanId: string = '';
  private theQueryIsEffected: string = '';
  private tradeQuery = 'trade';
  private teamQuery = 'team';
  private shiftQuery = 'shift';
  private current_plan_id: number = -1;
  private cur_plan_start_date: Date = new Date();
  private cur_plan_end_date: Date = new Date();
  public static tradeExchangeText = '';
  public static tradeExchangeIds = '';
  private isInitial = true;
  public static teamExchangeText = '';
  public static teamExchangeIds = '';
  private allowToFire: boolean = true;
  private theCurrentEl: any = [];
  private current_plan_data: any = undefined;
  private source = axios.CancelToken.source();
  private buttonShiftAssignment: ButtonPropsModel[] = [
    {
      click: () => {
        this.shiftAssignment();
      },
      buttonModel: {
        content: 'Yes',
        isPrimary: true,
      },
    },
    {
      click: () => {
        this.setState({ hideDeleteDialog: false });
      },
      buttonModel: {
        content: 'No',
        isPrimary: false,
      },
    },
  ];
  private buttonTeamAssignment: ButtonPropsModel[] = [
    {
      click: () => {
        this.teamAssignment();
      },
      buttonModel: {
        content: 'Yes',
        isPrimary: true,
      },
    },
    {
      click: () => {
        this.setState({ hideAssignTeamDialog: false });
      },
      buttonModel: {
        content: 'No',
        isPrimary: false,
      },
    },
  ];
  private buttonPercentage: ButtonPropsModel[] = [
    {
      click: () => {
        this.setPercentage();
      },
      buttonModel: {
        content: 'Yes',
        isPrimary: true,
      },
    },
    {
      click: () => {
        this.setState({ hidePercentage: false });
      },
      buttonModel: {
        content: 'No',
        isPrimary: false,
      },
    },
  ];
  private buttonScheduler: ButtonPropsModel[] = [
    {
      click: (args: any) => {
        this.schedulerGanttRecords();
      },
      buttonModel: {
        content: 'Yes',
        isPrimary: true,
      },
    },
    {
      click: () => {
        this.setState({ hideSchedulerTimeDialog: false });
      },
      buttonModel: {
        content: 'No',
        isPrimary: false,
      },
    },
  ];
  private buttonFilter: ButtonPropsModel[] = [
    {
      click: () => {
        this.applyFilter();
      },
      buttonModel: {
        content: 'Apply',
        isPrimary: true,
      },
    },
    {
      click: () => {
        this.setState({ hideFilterDialog: false });
      },
      buttonModel: {
        content: 'Cancel',
        isPrimary: false,
      },
    },
  ];
  private gantObj: GanttComponent = new GanttComponent({});
  private sidebarobj: SidebarComponent = new SidebarComponent({});
  private dropDownListObjectShiftElment: DropDownListComponent =
    new DropDownListComponent({});
  private multiselectObj: MultiSelectComponent = new MultiSelectComponent({});
  private multiselectForTradeObj: MultiSelectComponent =
    new MultiSelectComponent({});
  private dateTimePicker: DateTimePickerComponent = new DateTimePickerComponent(
    {}
  );
  private eventDropDown: DropDownListComponent = new DropDownListComponent({});
  private planDropDown: DropDownListComponent = new DropDownListComponent({});
  private resourceFields: object = {
    id: 'resourceId',
    name: 'resourceName',
  };
  private timelineSettings: TimelineSettingsModel = {
    weekStartDay: 1,
    timelineUnitSize: 60,
    topTier: {
      format: 'MMM dd, yyyy',
      unit: 'Week',
      count: 52,
    },
    bottomTier: {
      unit: 'Hour',
      format: 'EEE, dd',
      count: 24,
    },
  };
  private labelSettings: object = {
    leftLabel: 'TaskName',
    rightLabel: 'Resources',
    taskLabel: '${Progress}%',
  };
  constructor(props: IProps) {
    super(props);
    this.dropDown = new DropDownListComponent(props);
    this.state = {
      teamIds: [],
      eventsData: [],
      resourceData: [],
      currentIcon: <FaAngleDown size='12px' />,
      status: false,
      loadGant: [],
      planData: [],
      GantData: [],
      projectStartDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ),
      projectEndDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth() + 1,
        0
      ),
      isSidebarOpen: false,
      hideDeleteDialog: false,
      hideAssignTeamDialog: false,
      ShiftElementData: [],
      settingsDialog: false,
      hideFilterDialog: false,
      trades_data: [],
      tradesValues: [1, 2, 3, 4, 5],
      expandableButton: false,
      allowRender: false,
      queryForLoad: "'8/1/2022 8:00:00'$'8/31/2022 8:00:00'$33$'8:00:00'",
      dayWorkingTime: [{ from: 0, to: 24 }],
      hideSchedulerTimeDialog: false,
      currentDialogSettings: {
        width: '700px',
        height: 'auto',
        firstButtonText: 'Save',
        seccondButtonText: 'Cancel',
        type: 'exeption',
        content: undefined,
        show: false,
      },
      current_plan_isLocked: false,
      maxSchedulerPeriod: 0,
      hideGant: false,
      hideDialogOrder: false,
      allowDragDrop: false,
      allowSeg: false,
      hidePercentage: false,
      query: '',
      refreshToken: '',
    };
    this.dropDown.width = '70px';
  }
  //Components stuff
  async componentDidMount() {
    this.isMountedCS = true;
    this.current_query = await applyTheRule('uw_order', 'Cloud Scheduler');
    if (this.current_query !== '') {
      Message.info(
        'The query is applied from the rule. Consider to remove it from the rules'
      );
    }
    let theValue = localStorage.getItem('cs-drag-drop-enabled');
    let theValueAllowSeg = localStorage.getItem('cs-allow-seg-enabled');
    if (theValue === 'true') {
      this.setState({ allowDragDrop: true });
    } else {
      this.setState({ allowDragDrop: false });
    }
    if (theValueAllowSeg === 'true') {
      this.setState({ allowSeg: true });
    } else {
      this.setState({ allowSeg: false });
    }
    await this.getEvent();
    this.getShiftElments();
    this.getTradePerson();
    this.getMaxSchedulerSettings('supervisor-control$max-scheduler-period');
    let theEventID = Number(localStorage.getItem('cs_event_dd_value'));
    let thePlanID = Number(localStorage.getItem('cs_plan_dd_value'));
    if (theEventID !== 0 && thePlanID !== 0) {
      if (this.eventDropDown) this.eventDropDown.value = theEventID;
      this.onChangeEventPlan(false, {
        value: theEventID,
        plan_id: thePlanID,
        isTheSavedPlan: true,
      });
    } else {
      this.props.dispatch(
        setIsPlanSelected({
          isOrderPlanSelected: true,
          isOpPlanSelected: true,
          planId: 0,
        })
      );
    }
  }

  componentWillUnmount(): void {
    this.isMountedCS = false;
    this.source.cancel();
  }
  //Gantt Settings
  private contextMenuOpen(args: any): void {
    let record: IGanttData = args.rowData;
    if (args.type !== 'Header') {
      if (!record?.hasChildRecords) {
        args.hideItems.push('Collapse the Row');
        args.hideItems.push('Expand the Row');
      } else {
        if (record?.expanded) {
          args.hideItems.push('Expand the Row');
        } else {
          args.hideItems.push('Collapse the Row');
        }
      }
    }
  }
  private contextMenuClick(args: any): void {
    let record: any = args.rowData as any;
    if (args.item.id === 'collapserow') {
      this.gantObj.collapseByID(Number(record.ganttProperties.taskId));
    }
    if (args.item.id === 'expandrow') {
      this.gantObj.expandByID(Number(record.ganttProperties.taskId));
    }
    if (args.item.id === 'asignshift') {
      if (record.hasChildRecords) {
        this.current_data = record.childRecords;
        this.setState({ hideDeleteDialog: true });
      } else {
        this.current_data = [{ ...record }];
        this.setState({ hideDeleteDialog: true });
      }
    }
  }
  timeLineChangeFunction(args: any) {
    if (args.value === 2) {
      this.gantObj.timelineSettings = {
        topTier: {
          unit: 'Day',
          format: 'MMM dd, yyyy',
        },
        bottomTier: {
          unit: 'Hour',
        },
        timelineUnitSize: 10,
      };
      this.gantObj?.refresh();
    } else {
      this.gantObj.timelineSettings = {
        topTier: {
          format: 'MMM dd, yyyy',
          unit: 'Week',
        },
        bottomTier: {
          unit: 'Hour',
        },
        timelineUnitSize: 10,
      };
      this.gantObj?.refresh();
    }
  }
  private gantCellQuery = (args: any) => {
    if (
      args.column &&
      args.column.field === 'isChecked' &&
      args.data &&
      args.cell
    ) {
      let theData = args.data.taskData as any;
      if (theData) {
        let isChecked = theData.isRejected;
        let theCurrenColor = 'tranparent';
        if (isChecked) {
          if (theData.reason) {
            let theParseReason = theData?.reason?.split('^&&');
            let theColorEl = theParseReason[0].split('$');
            if (theColorEl.length > 0) {
              theCurrenColor = theColorEl[1];
            }
          }
        }
        args.cell.setAttribute(
          'style',
          `background-color:${theCurrenColor} !important;`
        );
      }
    }
    if (
      args.column &&
      args.column.type === 'checkbox' &&
      args.data &&
      args.cell
    ) {
      let isEffected = args.data.isEffected;
      let theCurrenColor = 'transparent';
      if (isEffected) {
        theCurrenColor = '#8ECDDD';
      }
      args.cell.setAttribute(
        'style',
        `background-color:${theCurrenColor}!important;`
      );
    }

    if (args.data.level === 0) {
      args.cell.classList.add('gantt-row-level-0');
      if (
        args.column.field === 'required' &&
        args.data.childRecords.length > 0
      ) {
        args.cell.innerHTML = Number(
          args.data.childRecords.reduce(
            (a: any, b: any) => Number(a) + Number(b.required),
            0
          )
        ).toFixed(2);
      }
    }
  };
  //RequestZone
  async getPlan(event_id: Number) {
    await getPlan(event_id).then((res) => {
      res.data.unshift({
        plan_name: '',
        ID: -1,
      });
      this.setState({ planData: res.data });
    });
  }
  async getEvent() {
    await getEvents().then((result) => {
      result.data.unshift({
        eventCode: '',
        eventId: -1,
      });
      if (this.isMountedCS) {
        this.setState({
          eventsData: result.data,
        });
      }
    });
  }
  getTradePerson() {
    axios
      .get(GetBackendUrlForGlobalFunctions() + `assignment`)
      .then((res: any) => {
        this.setState({
          resourceData: res.data?.map((el: any) => {
            return {
              resourceName: el.alias_name,
              resourceId: el.assignment_id,
            };
          }),
        });
      });
  }
  private getMaxSchedulerSettings(query: string) {
    GetGanttSettings(query).then((res) => {
      if (this.isMountedCS) {
        if (res.data[0]) {
          let value = res.data[0]?.value;
          if (!isNaN(value)) {
            this.setState({ maxSchedulerPeriod: value });
          }
        }
      }
    });
  }
  async getPlanOrderGant(cond: string) {
    let id = cond.toString();
    loadingShow(true, 'Loading');
    if (this.props.isSuperVisor) {
      id += '$true';
    }
    let theData = await GetGanttDataByPlan(id);
    this.ganttDatas = theData;
    if (theData.length === 1) {
      if (theData[0].order_id === null && theData[0].order_code === null) {
        Message.info('No data to show.');
        return;
      }
    }
    const model = [];
    for (let i = 0; i < theData.length; i++) {
      const res = theData[i];
      if (res.order_id === null || res.order_code === null) {
        continue;
      }
      model.push({
        ...res,
        EndDate: res.planned_end_date,
        StartDate: res.planned_start_date,
        TaskID: res.order_id,
        TaskName: res.order_code + ' - ' + res.description,
        isChecked: false,
        isEffected: res.isEffected,
        subtasks: res.subtasks.map((sub: any) => {
          return {
            ...sub,
            isRejected: res.isRejected,
            Duration: sub?.duration,
            Progress: sub?.percentage,
            Segments: sub?.Segments ? sub?.Segments : [],
            isDone: res?.isDone,
            StartDate:
              sub?.scheduledStartDate !== null
                ? sub?.scheduled_start_date
                : sub?.plannedStartDate !== null
                ? sub?.plannedStartDate
                : '',
            EndDate:
              sub?.scheduledEndDate !== null
                ? sub?.scheduledEndDate
                : sub?.plannedEndDate !== null
                ? sub?.plannedEndDate
                : '',
            TaskID: sub?.operationId,
            Work: Number(sub?.estHours),
            TaskName:
              sub?.operationSequence + ' - ' + sub?.operationDescription,
            info: sub?.longDescription,
            Predecessor: sub?.dependencyCode,
            long_description: `<${sub?.tradeCode}> ${res.description}`,
            asset_code: sub?.assetCode,
            type_code: sub?.typeCode,
            priority_code: sub?.priority,
            isChecked: false,
            isEffected: res.isEffected,
          };
        }),
      });
    }
    loadingShow(false);
    if (this.isMountedCS) {
      this.gantObj.dataSource = model;
      this.gantObj?.dataBind();
    }
  }
  private buildQuery = () => {
    this.current_query = this.current_query.trimEnd();
    this.current_query = this.current_query.replace(this.theQueryPlanId, '');
    this.current_query = this.current_query.replace(
      this.theQueryIsEffected,
      ''
    );
    this.theQueryPlanId = '';
    this.theQueryIsEffected = '';
    if (this.current_plan_id !== 0) {
      if (this.current_query !== '') {
        this.theQueryPlanId = addToQuery(
          'plan_id',
          '=',
          'andWhere',
          this.current_plan_id?.toString()
        );
      } else {
        this.theQueryPlanId = addToQuery(
          'plan_id',
          '=',
          'where',
          this.current_plan_id?.toString()
        );
      }
      this.current_query += this.theQueryPlanId;
    }
    if (this.props.isSuperVisor) {
      if (this.current_query !== '') {
        this.theQueryIsEffected = addToQuery(
          'is_effected',
          '=',
          'andWhere',
          '1'
        );
      } else {
        this.theQueryIsEffected = addToQuery('is_effected', '=', 'where', '1');
      }
      this.current_query += this.theQueryIsEffected;
    }
    this.getPlanOrderGant(this.current_query);
  };
  select(args: any) {
    let workingDays: Array<any> = [];
    if (this.multiselectObj.value) {
      workingDays = this.multiselectObj.value;
    }
    workingDays.push(args.itemData.day);
    this.gantObj.workWeek = workingDays;
  }

  ///DialogButton Submit
  setProgressGanttRecords() {
    this.allowToFire = false;
    let theAllChildsFromParent: Array<any> = [];
    var theData = this.gantObj.selectionModule.getSelectedRecords() as any;
    var theParents: Array<string> = [];
    if (!this.percentageNumber.value) {
      Message.error('Value must be between %0-%100');
      return;
    }
    theData?.map((theEl: any) => {
      if (!theEl.hasChildRecords) {
        theAllChildsFromParent.push(theEl);
        theParents.push(theEl.parentItem.index);
      }
    });
    const parents = new Set(theParents.map((el) => el));
    theParents = Array.from(parents);
    theParents.map((el) => {
      var theSelectedData = this.gantObj.flatData[parseInt(el)] as any;
      theSelectedData.isDone = true;
      this.gantObj.updateRecordByID(theSelectedData);
    });
    theAllChildsFromParent?.map((theChild, index) => {
      if (index === theAllChildsFromParent.length - 1) {
        this.allowToFire = true;
      }
      var theSelectedData = this.gantObj.flatData[theChild.index] as any;
      theSelectedData.Progress = this.percentageNumber.value;
      theSelectedData.isDone = true;
      this.gantObj.updateRecordByID(theSelectedData);
    });
    this.setState({
      currentDialogSettings: {
        ...this.state.currentDialogSettings,
        show: false,
      },
    });
  }

  applyConfirm() {
    if (this.current_plan_data) {
      this.current_plan_data.isLocked = !this.current_plan_data.isLocked;
      this.editPlans(this.current_plan_data);
      this.setState({
        currentDialogSettings: {
          ...this.state.currentDialogSettings,
          show: false,
        },
      });
    }
  }
  approveSendBack = () => {
    this.batch_obj = [];
    this.theCurrentEl.level = 0;
    let theResult = '';
    var theData: any;
    if (this.reasonCodes.value) {
      theData = this.reasonCodes.getDataByValue(
        this.reasonCodes.value.toString()
      ) as any;
    }
    if (this.reasonCodes.text) {
      theResult = this.reasonCodes.text;
    }
    if (this.reasonDesc.value) {
      theResult = theResult + ' ' + this.reasonDesc.value + '$' + theData.color;
    } else {
      theResult = theResult + '$' + theData.color;
    }
    this.theCurrentEl.reason =
      theResult + '^&&' + this.theCurrentEl.taskData.reason;
    this.batch_obj = [];
    arrayPreparing(
      [{ ...this.theCurrentEl }],
      this.batch_obj,
      this.state.allowSeg,
      this.state.dayWorkingTime,
      this.state.ShiftElementData
    );
    SavePointOfTheGantt(this.batch_obj, () => {
      $('#cloudSchedulerSavePoint').removeAttr('disabled');
      this.setState({
        currentDialogSettings: {
          ...this.state.currentDialogSettings,
          show: false,
        },
      });
    });
  };

  schedulerGanttRecords() {
    if (this.dateTimePicker.value === null) {
      Message.error('Scheduler date is mandatory');
      return;
    }
    this.reSchedulerGantt(false, '', this.dateTimePicker.value);
  }
  //DialogContent and Related Functions
  private onCreateConditionTextArea = (): void => {
    this.reasonDesc.addAttributes({ rows: 5 });
    this.reasonDesc.respectiveElement.style.height = '200px';
    this.reasonDesc.respectiveElement.style.overflow = 'auto';
    this.reasonDesc.respectiveElement.style.maxHeight = '200px';
  };
  private contentOfExeption = () => {
    return (
      <div className='flex-group-field'>
        <label htmlFor='Task' className='label-control col-md-3'>
          Exeption
        </label>
        <div className='col-md-12'>
          <DropDownListComponent
            onFocus={() => {
              axios
                .get(GetBackendUrlForGlobalFunctions() + 'scheduler-generals', {
                  cancelToken: this.source.token,
                })
                .then((res) => {
                  this.reasonCodes.dataSource = res.data.map((el: any) => {
                    return {
                      ...el,
                      name: el.name + ' ' + el.description,
                    };
                  });
                });
            }}
            fields={{ text: 'name', value: 'ID' }}
            placeholder='Task'
            valueTemplate={this.itemTemplate.bind(this)}
            itemTemplate={this.itemTemplate.bind(this)}
            ref={(scope: DropDownListComponent) => {
              this.reasonCodes = scope;
            }}
          />
        </div>
        <label className='label-control col-md-3'>Description</label>
        <div className='col-md-12'>
          <TextBoxComponent
            created={this.onCreateConditionTextArea}
            ref={(scope) => {
              this.reasonDesc = scope;
            }}
            multiline={true}
            style={{ maxHeight: '100px' }}
          />
        </div>
      </div>
    );
  };
  private onChipClik = (args: any) => {
    if (args.index === 0) {
      this.percentageNumber.value = 25;
    } else if (args.index === 1) {
      this.percentageNumber.value = 50;
    } else if (args.index === 2) {
      this.percentageNumber.value = 75;
    } else {
      this.percentageNumber.value = 100;
    }
  };
  private contentOfPercentage = () => {
    return (
      <div>
        <ChipListComponent
          id='chip-choice'
          selection='Single'
          cssClass='e-outline'
          selectedChips={[1]}
          click={this.onChipClik}
        >
          <ChipsDirective>
            <ChipDirective
              text='25%'
              leadingIconCss='e-medium-ico'
            ></ChipDirective>
            <ChipDirective
              text='50%'
              leadingIconCss='e-small-icon'
            ></ChipDirective>
            <ChipDirective
              text='75%'
              leadingIconCss='chip-choice'
            ></ChipDirective>
            <ChipDirective
              text='100%'
              leadingIconCss='chip-choice'
            ></ChipDirective>
          </ChipsDirective>
        </ChipListComponent>
        <NumericTextBoxComponent
          ref={(ref: NumericTextBoxComponent) => (this.percentageNumber = ref)}
          max={100}
          min={0}
          width={'100%'}
        />
      </div>
    );
  };
  private contentOfConfirm = () => {
    return (
      <div>
        Do you realy want to lock this plan. It may cause some unexpected
        beaviour.
      </div>
    );
  };
  private itemTemplateReasonValue(data: any): JSX.Element {
    return (
      <span>
        <span
          id='exceptiontColor'
          style={{ backgroundColor: data.color }}
        ></span>
        <span>{data.description}</span>
      </span>
    );
  }
  private contentOfHistory = () => {
    let theValues: string = this.theCurrentEl.taskData.reason;
    let theDataSource: Array<any> = [];
    if (theValues && theValues !== null) {
      let theReasons = theValues?.split('^&&');
      theReasons.map((els) => {
        let theParsing = els?.split('$');
        let theColor;
        if (theParsing.length > 0) theColor = theParsing[1];
        theDataSource.push({ description: theParsing[0], color: theColor });
      });
    } else {
      theDataSource = [{ description: 'No data to show.', color: '#fff' }];
    }
    return (
      <div>
        <span>History</span>
        <ListViewComponent
          className={'hiddenListElement'}
          id='cloudscheduler-list-flat'
          dataSource={theDataSource}
          template={this.itemTemplateReasonValue.bind(this)}
          cssClass='e-list-template'
          animation={{
            effect: 'SlideLeft',
            duration: 500,
            easing: 'ease',
          }}
          height={'200px'}
        ></ListViewComponent>
      </div>
    );
  };

  ///Helpers
  ConvertToSchedule(planned: any, schedule: any) {
    let val = planned;
    let indexOf = schedule.indexOf('(-');
    if (indexOf != -1) val = schedule;
    var num = parseInt(val.substring(6, 19));
    //var num = parseInt(str.replace(/[^09]/g, ""));
    var date = new Date(num);
    const month = date.getMonth();
    const day = date.getDate();
    const year = date.getFullYear();
    const result =
      (month < 10 ? '0' + month : month) +
      '/' +
      (day < 10 ? '0' + day : day) +
      '/' +
      year;
    return result;
  }
  ConvertToDateToGantModule(val: any) {
    var num = parseInt(val.substring(6, 19));
    var date = moment(num).format('MM/DD/yyyy');
    return new Date(date);
  }
  calculateClose() {
    if (this.condition) {
      this.gantObj.height = 'calc(-390px + 100vh)';
    } else {
      this.gantObj.height = 'calc(-90px + 100vh)';
    }
    this.condition = !this.condition;
  }
  getTimeZoneDifference() {
    var tz = moment(new Date()).utcOffset();
    var result = tz - -300;
    return result * 60000;
  }
  itemTemplate(data: any): JSX.Element {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '5px',
          marginLeft: '5px',
        }}
      >
        <div
          style={{
            backgroundColor: data.color,
            width: '20px',
            height: '20px',
            borderRadius: '5px',
          }}
        ></div>
        <span>{data.description}</span>
      </div>
    );
  }
  //OnClickEvent

  onChange(sel: { itemData: { text: string; value: string } }): void {
    this.gantObj.filterSettings.type = sel.itemData.value as FilterType;
    this.gantObj.clearFiltering();
  }
  async onChangeEventPlan(isFirst: boolean, args: any) {
    loadingShow(true);
    localStorage.setItem('cs_event_dd_value', args.value);
    this.isInitial = true;
    const eventId = args.value;
    await this.getPlan(eventId);
    const plan_id =
      this.state.planData.length > 0 ? this.state.planData[1]?.ID : null;
    if (eventId === -1) {
      this.setState({
        GantData: [],
        hideGant: false,
        loadGant: [],
        planData: [],
      });
      this.gantObj.dataSource = [];
      this.props.dispatch(
        setIsPlanSelected({
          isOrderPlanSelected: true,
          isOpPlanSelected: true,
          planId: 0,
        })
      );
      localStorage.removeItem('cs_event_dd_value');
      localStorage.removeItem('cs_plan_dd_value');
      loadingShow(false);
      return;
    }
    if (this.state.planData.length === 2 || args.isTheSavedPlan) {
      let thePlan = this.state.planData[1];
      if (args.isTheSavedPlan) {
        this.planDropDown && (this.planDropDown.value = args.plan_id);
        if (this.state.planData.length === 1) {
          loadingShow(false);
          return;
        } else {
          this.onChangePlan(isFirst, { value: args.plan_id });
        }
        return;
      }
      if (plan_id !== null) {
        localStorage.setItem('cs_plan_dd_value', plan_id);
        this.planDropDown && (this.planDropDown.value = plan_id);
        this.current_plan_data = thePlan;
        this.cur_plan_start_date = thePlan.planned_start_date;
        this.cur_plan_end_date = thePlan.planned_end_date;
        this.setState({
          current_plan_isLocked: thePlan.isLocked,
        });
        this.current_plan_id = thePlan.ID;
        this.props.dispatch(
          setIsPlanSelected({
            isOrderPlanSelected: true,
            isOpPlanSelected: true,
            planId: thePlan.ID,
          })
        );
        this.buildQuery();
        var startDate = moment(
          new Date(this.cur_plan_start_date).setDate(
            new Date(this.cur_plan_start_date).getDate() - 7
          )
        ).format('yyy-MM-DD');
        var endDate = moment(
          new Date(this.cur_plan_start_date).setDate(
            new Date(this.cur_plan_start_date).getDate() + 14
          )
        ).format('yyy-MM-DD');
        this.setInitialParamters(startDate, endDate);
        // CloudScheduler.start_date = thePlan.planned_start_date;
        CloudScheduler.isDateChangeRequest = true;
        this.context.setPlanId(this.current_plan_id);
        this.context.setLoadAllowChange(true);
        if (isFirst) {
          this.context.setResourcesAllowChange(true);
        }
      }
    } else {
      this.setState({
        GantData: [],
        hideGant: false,
        loadGant: [],
      });
      this.gantObj.dataSource = [];
      this.props.dispatch(
        setIsPlanSelected({
          isOrderPlanSelected: true,
          isOpPlanSelected: true,
          planId: 0,
        })
      );
      loadingShow(false);
    }
    loadingShow(false);
  }

  async onChangePlan(isFirst: boolean, args: any) {
    loadingShow(true);
    this.isInitial = true;
    this.current_plan_id = args.value;
    localStorage.setItem('cs_plan_dd_value', args.value);
    if (-1 === args.value) {
      this.setState({
        GantData: [],
        hideGant: false,
      });
      this.props.dispatch(
        setIsPlanSelected({
          isOrderPlanSelected: true,
          isOpPlanSelected: true,
          planId: 0,
        })
      );
      this.gantObj.dataSource = [];
      localStorage.removeItem('cs_plan_dd_value');
    } else {
      var theElement = this.state.planData.filter((el) => {
        return el.ID === args.value;
      });
      this.current_plan_data = theElement[0];
      this.cur_plan_start_date = theElement[0]?.planned_start_date;
      this.cur_plan_end_date = theElement[0]?.planned_end_date;
      var startDate = moment(
        new Date(CloudScheduler.start_date).setDate(
          new Date(CloudScheduler.start_date).getDate()
        )
      ).format('yyy-MM-DD');
      var endDate = moment(
        new Date(
          new Date(CloudScheduler.start_date).setDate(
            CloudScheduler.start_date.getDate() + 3 * 7
          )
        )
      ).format('yyy-MM-DD');
      this.setState({
        current_plan_isLocked: theElement[0]?.isLocked,
        projectStartDate: new Date(CloudScheduler.start_date),
        projectEndDate: new Date(endDate),
      });
      this.props.dispatch(
        setIsPlanSelected({
          isOrderPlanSelected: true,
          isOpPlanSelected: true,
          planId: args.value,
        })
      );
      this.setInitialParamters(startDate, endDate);
      CloudScheduler.isDateChangeRequest = true;
      // CloudScheduler.start_date = theElement[0]?.planned_start_date;
      this.context.setLoadAllowChange(true);
      this.context.setPlanId(this.current_plan_id);
      // this.context.setMaterialAllowChange(true);
      if (isFirst) {
        this.context.setResourcesAllowChange(true);
      }
    }
    loadingShow(false);
  }
  setInitialParamters(startDate: string, endDate: string) {
    if (this.teamTexts.length > 0 && this.teamValues.length > 0) {
      let theTempValue = '';
      this.teamTexts.map((el, index: number) => {
        theTempValue += `''${el}''`;
        if (index !== this.teamTexts.length - 1) {
          theTempValue += ',';
        }
      });
      theTempValue = `'${theTempValue}'`;
      var theValuesIds = this.teamValues;
      CloudScheduler.teamExchangeText = theTempValue;
      CloudScheduler.teamExchangeIds = `'${theValuesIds?.toString()}'`;
      this.tradeQuery = `'${theValuesIds?.toString()}'`;
    } else {
      this.tradeQuery = 'team';
      CloudScheduler.teamExchangeText = '';
      CloudScheduler.teamExchangeIds = '';
    }
    if (this.tradeTexts.length > 0 && this.tradeValues.length > 0) {
      let theTempValue = '';
      this.tradeTexts.map((el, index: number) => {
        theTempValue += `''${el}''`;
        if (index !== this.tradeTexts.length - 1) {
          theTempValue += ',';
        }
      });
      theTempValue = `'${theTempValue}'`;
      var theValuesIds = this.tradeValues;
      CloudScheduler.tradeExchangeText = theTempValue;
      CloudScheduler.tradeExchangeIds = `'${theValuesIds?.toString()}'`;
      this.tradeQuery = `'${theValuesIds?.toString()}'`;
    } else {
      this.tradeQuery = 'trade';
      CloudScheduler.tradeExchangeText = '';
      CloudScheduler.tradeExchangeIds = '';
    }
    var timeZoneDiff = Number(this.getTimeZoneDifference()) / (60000 * 60);
    var end = new Date(
      new Date(startDate).setDate(new Date(startDate).getDate() + 21)
    );
    var resultKPIQuery = `'${startDate} ${timeZoneDiff}:00:00'$'${moment(
      end
    ).format('yyy-MM-DD')} ${timeZoneDiff}:00:00'$${
      this.current_plan_id
    }$'${timeZoneDiff}:00:00'$${this.tradeQuery}`;
    var sonucLoad = `'${startDate} ${timeZoneDiff}:00:00'$'${moment(end).format(
      'yyy-MM-DD'
    )} ${timeZoneDiff}:00:00'$${this.current_plan_id}$'${timeZoneDiff}:00:00'$${
      this.tradeQuery
    }`;
    this.buildQuery();
    CloudScheduler.queryForLoad = sonucLoad;
    this.setState({
      query: resultKPIQuery,
    });
    this.setState({ queryForLoad: sonucLoad });
  }
  private modifiedDatas: any = [];
  async actionCompletedElement(args: any) {
    if (args.action === 'DialogEditing' || args.action === 'TaskbarEditing') {
      if (this.allowToFire) {
        this.batch_obj = [];
      }
      this.modifiedDatas.push(args.modifiedRecords);
      //this.schedulerGanttRecords()
      //this.EditOperationAndOrderDatas()
      this.reSchedulerGantt(false, '', args.data.StartDate);
    } else if (args.requestType === 'save') {
      if (this.allowToFire) {
        this.batch_obj = [];
      }
      this.modifiedDatas.push(args.modifiedRecords);
      // arrayPreparing(
      //   args.modifiedRecords,
      //   this.batch_obj,
      //   this.state.allowSeg,
      //   this.state.dayWorkingTime,
      //   this.state.ShiftElementData
      // );
      // if (this.allowToFire) {
      //   await SavePointOfTheGantt(this.batch_obj, () => {
      //     this.setState({
      //       currentDialogSettings: {
      //         ...this.state.currentDialogSettings,
      //         show: false,
      //       },
      //     });
      //     this.context.setLoadAllowChange(true);
      //     this.setState({
      //       query: CloudScheduler.queryForLoad,
      //       refreshToken: Math.random().toString(),
      //     });
      //     this.allowToFire = false;
      //     args.modifiedRecords.map((theChild: any, index: any) => {
      //       var theSelectedData = this.gantObj.flatData[theChild.index] as any;
      //       theSelectedData.Duration = theChild.Duration;
      //      // this.gantObj.updateRecordByID(theSelectedData);
      //     });
      //     this.allowToFire = true;
      //     CloudScheduler.isDateChangeRequest = true;
      //     // this.buildQuery();
      //     // if (true && this.state.allowSeg) {
      //     // }
      //   });
      // }
    }
  }
  private operationDatas: any = [];
  async EditOperationAndOrderDatas() {
    // for (var i = 0; i < this.modifiedDatas[0].length; i++) {
    let operationData = arrayPreparing(
      this.modifiedDatas,
      this.batch_obj,
      this.state.allowSeg,
      this.state.dayWorkingTime,
      this.state.ShiftElementData
    );
    this.modifiedDatas = [];
    //this.operationDatas.push(operationData.datas);
    await EditOperations(operationData.datas)
      .then(() => {
        loadingShow(false);
        this.operationDatas = [];
        this.modifiedDatas = [];
      })
      .catch((err: any) => {});
    this.operationDatas = [];
    if (this.allowToFire) {
      await SavePointOfTheGantt(operationData.theBatchArray, () => {
        this.setState({
          currentDialogSettings: {
            ...this.state.currentDialogSettings,
            show: false,
          },
        });
        this.context.setLoadAllowChange(true);
        this.setState({
          query: CloudScheduler.queryForLoad,
          refreshToken: Math.random().toString(),
        });
        this.allowToFire = false;
        // this.modifiedDatas[i].modifiedRecords.map((theChild: any, index: any) => {
        //   var theSelectedData = this.gantObj.flatData[theChild.index] as any;
        //   theSelectedData.Duration = theChild.Duration;
        //  // this.gantObj.updateRecordByID(theSelectedData);
        // });
        this.allowToFire = true;
        CloudScheduler.isDateChangeRequest = true;
        // this.buildQuery();
        // if (true && this.state.allowSeg) {
        // }
      });
    }
  }
  taskbarEditing(args: any) {
    if (
      args.taskBarEditAction == 'LeftResizing' ||
      args.taskBarEditAction == 'RightResizing'
    ) {
      args.cancel = true;
    }
  }
  private actionBegin(args: any) {
    if (args.requestType === 'taskbarediting') {
      // if (args.taskBarEditAction === 'RightResizing') {
      //   args.cancel = true;
      //   return;
      // }
      // if (args.taskBarEditAction === 'LeftResizing') {
      //   args.cancel = true;
      //   return;
      // }
    }
    if (args.requestType === 'beforeSave') {
      // args?.modifiedRecords.map((res: any) => {
      //   if (res.level === 0) {
      //     if (this.state.maxSchedulerPeriod === 0) {
      //       return;
      //     }
      //     res.childRecords.map((el: any) => {
      //       let theRangeEnd = Math.abs(
      //         moment(el.EndDate).diff(el.taskData.scheduled_end_date, 'days')
      //       );
      //       let theRangeStart = Math.abs(
      //         moment(el.StartDate).diff(el.taskData.scheduled_start_date, 'days')
      //       );
      //       let thePeriod = Number(this.state.maxSchedulerPeriod);
      //       if (theRangeEnd > thePeriod || theRangeStart > thePeriod) {
      //         args.cancel = true;
      //         Message.error(
      //           'Max scheduled range has exceeded. The Range must be 0-' +
      //             thePeriod
      //         );
      //         return;
      //       }
      //     });
      //   }
      // });
    }
  }
  private onLocked() {
    if (!this.current_plan_data.isLocked) {
      this.setState({
        currentDialogSettings: {
          width: '300px',
          height: 'auto',
          firstButtonText: 'Yes',
          seccondButtonText: 'No',
          type: 'confirm',
          content: this.contentOfConfirm.bind({}),
          show: true,
        },
      });
    } else {
      if (this.current_plan_data) {
        this.current_plan_data.isLocked = !this.current_plan_data.isLocked;
        this.editPlans(this.current_plan_data);
      }
    }
  }
  setPercentage() {
    this.reSchedulerGantt(
      false,
      undefined,
      undefined,
      true,
      this.percentage.value
    );
  }
  teamAssignment() {
    let selectedElement: Array<any> = Object.values(this.current_data);
    if (
      this.assignTeamDropDown?.value === undefined ||
      this.assignTeamDropDown?.value === null
    ) {
      Message.error('You should select a team');
      return;
    }
    if (selectedElement?.length > 0) {
      const obj = [
        ...selectedElement.map((el: any) => {
          let theCurrentTeam = this.assignTeamDropDown?.text;
          if (theCurrentTeam !== undefined || theCurrentTeam !== '') {
            let workingHour = Number(
              this.state.dayWorkingTime[0].to -
                this.state.dayWorkingTime[0].from
            );
            generateSegmentation(el, workingHour, this.state.allowSeg);
          }
          return {
            operationId: el.TaskID,
            teamCode: this.assignTeamDropDown?.text,
            createdBy: all_information.user_id,
            Segments: el?.taskData?.Segments
              ? [
                  ...el?.taskData?.Segments?.map((seg: any) => {
                    return {
                      StartDate: seg.StartDate,
                      Duration: seg.Duration,
                      operationId: el.TaskID,
                    };
                  }),
                ]
              : [],
          };
        }),
      ];
      EditOperations(obj)
        .then(() => {
          Message.success('Success');
          loadingShow(false);
          this.context.setLoadAllowChange(true);
          this.buildQuery();
          this.setState({ hideAssignTeamDialog: false });
        })
        .catch((err: any) => {
          if (err.response) {
            Message.error(
              err.response.data +
                '\n' +
                err.response.status +
                '\n' +
                err.response.headers
            );
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
          loadingShow(false);
        });
    }
  }
  shiftAssignment() {
    let selectedElement: Array<any> = Object.values(this.current_data);
    if (
      this.dropDownListObjectShiftElment.value === undefined ||
      this.dropDownListObjectShiftElment.value === null
    ) {
      Message.error('You should select a shift');
      return;
    }
    if (selectedElement.length > 0) {
      const obj = [
        ...selectedElement.map((el: any) => {
          let theCurrentShift = this.dropDownListObjectShiftElment.text;
          if (theCurrentShift !== undefined || theCurrentShift !== '') {
            let workingHour = Number(
              this.state.dayWorkingTime[0].to -
                this.state.dayWorkingTime[0].from
            );
            generateSegmentation(el, workingHour, this.state.allowSeg);
          } else {
            let theShift = this.state.ShiftElementData.filter((elShift) => {
              return (
                elShift.rosterCode === theCurrentShift &&
                elShift.rosterType === 'Shift'
              );
            });
            let workingHour = theShift[0].duration.split(':')[0];
            let workingMin = theShift[0].duration.split(':')[1];
            if (Number(workingHour) === 23 && Number(workingMin) === 59) {
              workingHour = 24;
            }
            generateSegmentation(el, workingHour, this.state.allowSeg);
          }
          return {
            operationId: el.TaskID,
            shift: this.dropDownListObjectShiftElment.text,
            shiftId: this.dropDownListObjectShiftElment.value,
            createdBy: all_information.user_id,
            Segments: el?.taskData?.Segments
              ? [
                  ...el?.taskData?.Segments?.map((seg: any) => {
                    return {
                      StartDate: seg.StartDate,
                      Duration: seg.Duration,
                      operationId: el.TaskID,
                    };
                  }),
                ]
              : [],
          };
        }),
      ];
      EditOperations(obj)
        .then(() => {
          Message.success('Success');
          loadingShow(false);
          this.context.setLoadAllowChange(true);
          this.buildQuery();
          this.setState({ hideDeleteDialog: false });
        })
        .catch((err: any) => {
          if (err.response) {
            Message.error(
              err.response.data +
                '\n' +
                err.response.status +
                '\n' +
                err.response.headers
            );
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
          loadingShow(false);
        });
    }
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };

  private itemTemplateShiftColor(data: any): JSX.Element {
    return (
      <span>
        <span
          id='exceptiontColor'
          style={{ backgroundColor: data.rostercolor }}
        ></span>
        <span>{data.rosterCode + ' - ' + data.description}</span>
      </span>
    );
  }

  public contextMenuItems: any = [
    'AutoFitAll',
    'AutoFit',
    'TaskInformation',
    'DeleteTask',
    'Save',
    'Cancel',
    'SortAscending',
    'SortDescending',
    'Add',
    'DeleteDependency',
    'Convert',
    'Indent',
    'Split Task',
    'Outdent',
    {
      text: 'Collapse the Row',
      target: '.e-content',
      id: 'collapserow',
    } as ContextMenuItemModel,
    {
      text: 'Expand the Row',
      target: '.e-content',
      id: 'expandrow',
    } as ContextMenuItemModel,
    {
      text: 'Assign Shift',
      target: '.e-content',
      id: 'asignshift',
    } as ContextMenuItemModel,
  ];

  removed(args: any) {
    let index = this.gantObj.workWeek.indexOf(args.itemData.day);
    if (index !== -1) {
      this.gantObj.workWeek = this.multiselectObj.value as any;
    }
  }
  toolbarClick(args: any) {
    if (args.item.id === 'cloud-scheduler-gantt_excelexport') {
      this.gantObj.excelExport();
    } else if (args.item.id === 'cloud-scheduler-gantt_csvexport') {
      this.gantObj.csvExport();
    } else if (args.item.id === 'cloud-scheduler-gantt_pdfexport') {
      this.gantObj.pdfExport({
        pageSize: 'A0',
        showPredecessorLines: true,
        enableFooter: true,
        theme: 'Bootstrap 4',
        ganttStyle: {
          // columnHeader:{
          //   padding:new PdfPaddings(2,2,2,2)
          // }
        },
      });
    }
    // if (args.item.text === 'Edit') {
    //   if (this.gantObj.selectionModule.getSelectedRecords().length !== 0) {
    //    this.EditOperationAndOrderDatas()
    //   } else {
    //     Message.error('No records selected to Assign');
    //   }
    // }
    if (args.item.id === 'assignshift') {
      if (this.gantObj.selectionModule.getSelectedRecords().length !== 0) {
        var theData = this.gantObj.selectionModule.getSelectedRecords() as any;
        let datas: Array<any> = [];
        theData?.map((data: any) => {
          if (data.hasChildRecords) {
            // data.childRecords.map((item: any)=>{
            //   datas.push(item);
            // })
            //this.current_data = data.childRecords;
            this.setState({ hideDeleteDialog: true });
          } else {
            //this.current_data = [{ ...data }];
            datas.push(data);
            this.setState({ hideDeleteDialog: true });
          }
        });
        this.current_data = datas;
      } else {
        Message.error('No records selected to Assign');
      }
    }
    if (args.item.id === 'assignteam') {
      if (this.gantObj.selectionModule.getSelectedRecords().length !== 0) {
        var theData = this.gantObj.selectionModule.getSelectedRecords() as any;
        let datas: Array<any> = [];
        theData?.map((data: any) => {
          if (data.hasChildRecords) {
            data.childRecords.map((item: any) => {
              datas.push(item);
            });
            //this.current_data = data.childRecords;
            this.setState({ hideAssignTeamDialog: true });
          } else {
            //this.current_data = [{ ...data }];
            datas.push(data);
            this.setState({ hideAssignTeamDialog: true });
          }
        });
        this.current_data = datas;
      } else {
        Message.error('No records selected to Assign');
      }
    }
    if (args.item.id === 'percentage') {
      if (this.gantObj.selectionModule.getSelectedRecords().length !== 0) {
        var theData = this.gantObj.selectionModule.getSelectedRecords() as any;
        if (theData[0].hasChildRecords) {
          this.current_data = theData[0].childRecords;
          this.setState({ hidePercentage: true });
        } else {
          this.current_data = [{ ...theData[0] }];
          this.setState({ hidePercentage: true });
        }
      } else {
        Message.error('No records selected to Assign');
      }
    }
    if (args.item.id === 'assign_workorders') {
      if (this.current_plan_id !== 0) {
        this.setState({ hideDialogOrder: true });
      } else {
        Message.error('No plan selected to Assign');
      }
    }
    if (args.item.id === 'scheduler') {
      if (this.gantObj.selectionModule.getSelectedRecords().length !== 0) {
        if (this.state.current_plan_isLocked) {
          Message.warning(
            'This plan has been locked down. This is not alowed to procced'
          );
          return;
        }
        this.setState({ hideSchedulerTimeDialog: true });
      } else {
        Message.error('No records selected to Assign');
      }
    }
    if (args.item.id === 'done') {
      if (this.gantObj.selectionModule.getSelectedRecords().length !== 0) {
        this.setState({
          currentDialogSettings: {
            width: '300px',
            height: 'auto',
            firstButtonText: 'Save',
            seccondButtonText: 'Cancel',
            type: 'done',
            content: this.contentOfPercentage.bind({}),
            show: true,
          },
        });
      } else {
        Message.error('No records selected to Assign');
      }
    }
    if (args.item.id === 'next') {
      if (this.gantObj.selectionModule.getSelectedRecords().length !== 0) {
        this.reSchedulerGantt(true, 'next');
      } else {
        Message.error('No records selected to Assign');
      }
    }
    if (args.item.id === 'previous') {
      if (this.gantObj.selectionModule.getSelectedRecords().length !== 0) {
        this.reSchedulerGantt(true, 'previous');
      } else {
        Message.error('No records selected to Assign');
      }
    }
    if (args.item.id === 'reject') {
      if (this.gantObj.selectionModule.getSelectedRecords().length !== 0) {
        var theData = this.gantObj.selectionModule.getSelectedRecords() as any;
        if (theData.hasChildRecords || theData[0].level === 0) {
          this.theCurrentEl = theData[0];
          this.theCurrentEl.isRejected = true;
          this.theCurrentEl.is_effected = false;
          this.theCurrentEl.order_id = this.theCurrentEl.TaskID;
        } else {
          let theParentData = this.gantObj.getRecordByID(
            theData[0].parentItem.taskId
          );
          this.theCurrentEl = theParentData;
          this.theCurrentEl.isRejected = true;
          this.theCurrentEl.is_effected = false;
          this.theCurrentEl.order_id = this.theCurrentEl.TaskID;
        }
        this.setState({
          currentDialogSettings: {
            width: '500px',
            height: 'auto',
            firstButtonText: 'Save',
            seccondButtonText: 'Cancel',
            type: 'exeption',
            content: this.contentOfExeption.bind({}),
            show: true,
          },
        });
      }
    }
    if (args.item.id === 'history') {
      if (this.gantObj.selectionModule.getSelectedRecords().length !== 0) {
        var theData = this.gantObj.selectionModule.getSelectedRecords() as any;
        if (theData.hasChildRecords || theData[0].level === 0) {
          this.theCurrentEl = theData[0];
        } else {
          let theParentData = this.gantObj.getRecordByID(
            theData[0].parentItem.taskId
          );
          this.theCurrentEl = theParentData;
        }
        this.setState({
          currentDialogSettings: {
            width: '500px',
            height: 'auto',
            firstButtonText: 'OK',
            seccondButtonText: 'Cancel',
            type: 'history',
            content: this.contentOfHistory.bind({}),
            show: true,
          },
        });
      }
    }
    if (args.item.id === 'refresh') {
      this.buildQuery();
      this.setState({ query: CloudScheduler.queryForLoad });
      this.context.setLoadAllowChange(true);
    }
    if (args.item.id === 'commit') {
      if (this.gantObj.selectionModule.getSelectedRecords().length !== 0) {
        var theData = this.gantObj.selectionModule.getSelectedRecords() as any;
        var theCurrentEl: any = [];
        if (theData.hasChildRecords || theData[0].level === 0) {
          theCurrentEl = { ...theData[0].taskData };
          theCurrentEl.isRejected = false;
          theCurrentEl.is_effected = true;
          theCurrentEl.order_id = theCurrentEl.TaskID;
        } else {
          let theParentData = this.gantObj.getRecordByID(
            theData[0].parentItem.taskId
          );
          theCurrentEl = { ...theParentData.taskData };
          theCurrentEl.isRejected = false;
          theCurrentEl.is_effected = true;
          theCurrentEl.order_id = theCurrentEl.TaskID;
        }
        theCurrentEl.subtasks = undefined;
        this.batch_obj.push(theCurrentEl);
        SavePointOfTheGantt(this.batch_obj, () => {
          this.setState({
            currentDialogSettings: {
              ...this.state.currentDialogSettings,
              show: false,
            },
          });
        });
        let current_query = '';
        let start_date = moment(theCurrentEl.StartDate).format(
          'yyyy-MM-DD HH:mm:ss'
        );
        let end_date = moment(theCurrentEl.EndDate).format(
          'yyyy-MM-DD HH:mm:ss'
        );
        current_query =
          `update job5mfc set jcm_start_date=TO_DATE('${moment(
            start_date
          ).format('yyyy-MM-DD HH:mm')}', "%Y-%m-%d %H:%M")
          , jcm_start_time=TO_DATE('${moment(start_date).format(
            'yyyy-MM-DD HH:mm'
          )}', "%Y-%m-%d %H:%M")
          ,cost_description='${theCurrentEl.TaskName}'
          where row_id=` +
          theCurrentEl.pronto_row_id +
          `;`;
        current_query +=
          ` update jobwodt3 set
          jobwodt3.est_finish_date=TO_DATE('${moment(end_date).format(
            'yyyy-MM-DD HH:mm'
          )}', "%Y-%m-%d %H:%M")
         , jobwodt3.est_finish_time=TO_DATE('${moment(end_date).format(
           'yyyy-MM-DD HH:mm'
         )}', "%Y-%m-%d %H:%M")
         where row_id=` + theCurrentEl.pronto_row_id;
        SendRequest(current_query, '');
      }
    }
  }

  private selectedChildList: Array<any> = [];
  rowSelected = (args: any) => {
    if (args?.data.TaskID) {
      if (args?.data?.childRecords.length > 0) {
        args?.data?.childRecords?.map((child: any) => {
          if (child.hasChildRecords != true) this.selectedChildList.push(child);
        });
        //this.selectedChildList = this.selectedChildList.filter(child => child !=args?.data);
      } else {
        if (args?.data.hasChildRecords != true)
          this.selectedChildList.push(args?.data);
      }
      this.selectedChildList = this.selectedChildList.filter(
        (child) => !Array.isArray(child)
      );
    } else {
      args?.data?.map((child: any) => {
        if (child.hasChildRecords != true && child.pronto_row_id === null) {
          this.selectedChildList.push(child);
        }
        this.selectedChildList = this.selectedChildList.filter(
          (child) => !Array.isArray(child)
        );
      });
    }
    this.selectedChildList = this.selectedChildList
      .filter((child) => !Array.isArray(child))
      .filter(
        (child, index, self) =>
          index ===
          self.findIndex((c) => JSON.stringify(c) === JSON.stringify(child))
      );
  };
  rowDeselected = (args: any) => {
    if (args?.data.TaskID) {
      if (args?.data?.childRecords.length > 0) {
        args?.data?.childRecords?.map((child: any, index: any) => {
          this.selectedChildList = this.selectedChildList.filter(
            (item) => child.TaskID !== item.TaskID
          );
        });
      } else {
        this.selectedChildList = this.selectedChildList.filter(
          (child) => child != args?.data
        );
      }
    } else {
      args?.data?.map((child: any) => {
        this.selectedChildList = this.selectedChildList.filter(
          (child) => !this.selectedChildList.includes(child)
        );
      });
    }
  };

  getSelectedChilds = (): Array<any> => {
    var theData = this.gantObj?.selectRows(this.selectedChildList) as any;
    let theAllChildsFromParent: Array<any> = [];
    //var theData = this.gantObj.selectionModule.getSelectedRecords() as any;
    theData?.map((theEl: any) => {
      if (!theEl.hasChildRecords) {
        theAllChildsFromParent.push(theEl);
      }
    });
    return theAllChildsFromParent;
  };
  reSchedulerGantt = async (
    isOneStepProcces: boolean,
    type?: string,
    date?: Date,
    isProgress?: boolean,
    progressValue?: number
  ) => {
    this.allowToFire = false;
    let dataChilds = this.selectedChildList;
    //let dataChilds = this.gantObj.selectionModule.getCellSelectedRecords();
    let datasToSend: Array<any> = [];

    dataChilds.map((theChild, index) => {
      //if (index === dataChilds.length - 1) {
      if (true) {
        this.allowToFire = true;
      }
      this.allowToFire = true;

      var theSelectedData = this.gantObj?.flatData[theChild.index] as any;
      if (isProgress) {
        theSelectedData.Progress = progressValue;
      } else {
        if (isOneStepProcces) {
          if (type === 'next') {
            let theCurrentDate = new Date(theSelectedData.StartDate);
            theCurrentDate.setDate(
              theCurrentDate.getDate() + Number(this.offset)
            );
            theSelectedData.StartDate = theCurrentDate;
          } else if (type === 'previous') {
            let theCurrentDate = new Date(theSelectedData.StartDate);
            theCurrentDate.setDate(
              theCurrentDate.getDate() - Number(this.offset)
            );
            theSelectedData.StartDate = theCurrentDate;
          }
        } else {
          if (theSelectedData) {
            theSelectedData.StartDate = date;
          }
        }
      }
      this.gantObj.updateRecordByID(theSelectedData);
    });
    await this.EditOperationAndOrderDatas();
    // arrayPreparing(
    //   this.gantObj.selectionModule.getSelectedRecords(),
    //   this.batch_obj,
    //   this.state.allowSeg,
    //   this.state.dayWorkingTime,
    //   this.state.ShiftElementData
    // );
    // let res = await EditOperations(datasToSend)
    // if (res.status === 200) {

    //   this.selectedChildList = []
    //   this.buildQuery();
    //   this.setState({ query: CloudScheduler.queryForLoad });
    //   this.context.setLoadAllowChange(true);
    //  //await EditGantt(this.batch_obj)
    // }
    this.setState({ hideSchedulerTimeDialog: false, hidePercentage: false });
  };

  editPlans(obj: any) {
    EditPlan(obj)
      .then((res: any) => {
        if (this.current_plan_data.isLocked) {
          Message.warning(
            `${this.current_plan_data.plan_name} has been locked down`
          );
          this.gantObj.editSettings = {
            allowAdding: false,
            allowEditing: false,
            allowDeleting: false,
            mode: 'Auto',
            showDeleteConfirmDialog: false,
          };
        } else {
          Message.success(
            `${this.current_plan_data.plan_name} has been unlock`
          );
          this.gantObj.editSettings = this.editSettings;
        }
        loadingShow(false);
        this.setState({
          current_plan_isLocked: this.current_plan_data.isLocked,
        });
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  handleOfLoadGridDateChange = (args: Date, weekCount: number) => {
    if (this.current_plan_id === -1) {
      return;
    }
    loadingShow(true, 'Loading...');
    let theTempValue = '';
    if (
      this.multiselectForTradeObj &&
      this.multiselectForTradeObj.value?.length &&
      this.multiselectForTradeObj.value?.length > 0
    ) {
      var theValuesText: Array<any> = [];
      if (this.multiselectForTradeObj.text?.split(',')) {
        theValuesText = this.multiselectForTradeObj.text?.split(',');
      }
      theValuesText?.map((el, index: number) => {
        theTempValue += `''${el}''`;
        if (index !== theValuesText.length - 1) {
          theTempValue += ',';
        }
      });
      theTempValue !== '' && (theTempValue = `'${theTempValue}'`);
      var theValuesIds = this.multiselectForTradeObj.value;
      var theTeamValuesIds = this.teamFMSCom.value;
      var theShiftValuesIds = this.shiftFMSCom.value;
      CloudScheduler.tradeExchangeText = theTempValue;
      CloudScheduler.tradeExchangeIds = `'${theValuesIds?.toString()}'`;
      this.tradeQuery = `'${theValuesIds?.toString()}'`;
      this.teamQuery = `'${theTeamValuesIds?.toString()}'`;
      this.shiftQuery = `'${theShiftValuesIds?.toString()}'`;
    } else {
      this.tradeQuery = 'trade';
      CloudScheduler.tradeExchangeText = '';
      CloudScheduler.tradeExchangeIds = '';
    }
    var timeZoneDiff = Number(this.getTimeZoneDifference()) / (60000 * 60);
    this.dateRangeValue[0] = new Date(new Date(args).setDate(args.getDate()));
    this.dateRangeValue[1] = new Date(
      new Date(args).setDate(args.getDate() + weekCount * 7)
    );
    var startDate = moment(new Date(args).setDate(args.getDate())).format(
      'yyy-MM-DD'
    );
    var endDate = moment(
      new Date(args).setDate(args.getDate() + weekCount * 7)
    ).format('yyy-MM-DD');
    var sonucLoad = `'${startDate} ${timeZoneDiff}:00:00'$'${endDate} ${timeZoneDiff}:00:00'$${this.current_plan_id}$'${timeZoneDiff}:00:00'$${this.tradeQuery}$${this.teamQuery}$${this.shiftQuery}`;
    CloudScheduler.queryForLoad = sonucLoad;
    CloudScheduler.start_date = moment(startDate).toDate();
    this.context.setLoadAllowChange(true);
    this.setState({
      query: CloudScheduler.queryForLoad,
      queryForLoad: sonucLoad,
      projectStartDate: this.dateRangeValue[0],
      projectEndDate: this.dateRangeValue[1],
    });
  };
  getShiftElments() {
    GetRosters().then((res) => {
      let filterData = res.data.filter((x: any) => x.rosterType === 'Shift');
      filterData.unshift({ rosterCode: '', rosterId: -1, description: '' });
      this.setState({ ShiftElementData: filterData });
    });
  }

  applyFilter() {
    if (this.current_plan_id === -1) {
      Message.error('Must selected a operation to use filter');
      return;
    }
    let theTempValue = '';
    if (
      this.multiselectForTradeObj &&
      this.multiselectForTradeObj?.value != undefined &&
      this.multiselectForTradeObj?.value?.length > 0
    ) {
      var theValuesText: Array<any> = [];
      if (
        this.multiselectForTradeObj.text &&
        this.multiselectForTradeObj.text !== undefined
      ) {
        theValuesText = this.multiselectForTradeObj.text.split(',');
        localStorage.setItem(
          'trades_text',
          this.multiselectForTradeObj.text.toString()
        );
      }
      localStorage.setItem(
        'trades',
        this.multiselectForTradeObj.value.toString()
      );

      if (
        this.teamFMSCom.value?.toString() &&
        this.teamFMSCom?.text?.toString()
      ) {
        localStorage.setItem('teams', this.teamFMSCom?.value?.toString());
        localStorage.setItem('teams_text', this.teamFMSCom?.text?.toString());
      }
      if (
        this.shiftFMSCom?.value?.toString() &&
        this.shiftFMSCom?.text?.toString()
      ) {
        localStorage.setItem('shifts', this.shiftFMSCom?.value?.toString());
        localStorage.setItem('shifts_text', this.shiftFMSCom?.text?.toString());
      }

      theValuesText.map((el, index: number) => {
        theTempValue += `''${el}''`;
        if (index !== theValuesText.length - 1) {
          theTempValue += ',';
        }
      });
      theTempValue = `'${theTempValue}'`;
      var theValuesIds = this.multiselectForTradeObj.value;
      var theTeamValuesIds = this.teamFMSCom.value;
      var theShiftValuesIds = this.shiftFMSCom.value;
      CloudScheduler.tradeExchangeText = theTempValue;
      CloudScheduler.tradeExchangeIds = `'${theValuesIds?.toString()}'`;
      this.tradeQuery = `'${theValuesIds?.toString()}'`;
      this.teamQuery = `'${theTeamValuesIds?.toString()}'`;
      this.shiftQuery = `'${theShiftValuesIds?.toString()}'`;
    } else {
      this.tradeQuery = 'trade';
      // this.teamQuery = 'team';
      // this.shiftQuery = 'shift';
      CloudScheduler.tradeExchangeText = '';
      CloudScheduler.tradeExchangeIds = '';

      var theTeamValuesIds = this.teamFMSCom.value;
      var theShiftValuesIds = this.shiftFMSCom.value;
      this.teamQuery = `'${theTeamValuesIds?.toString()}'`;
      this.shiftQuery = `'${theShiftValuesIds?.toString()}'`;
    }
    var timeZoneDiff = Number(this.getTimeZoneDifference()) / (60000 * 60);
    var startDate = moment(this.dateRangeValue[0]).format('yyy-MM-DD');
    var endDate = moment(this.dateRangeValue[1]).format('yyy-MM-DD');
    CloudScheduler.start_date = new Date(startDate);
    var sonucLoad = `'${startDate} ${timeZoneDiff}:00:00'$'${endDate} ${timeZoneDiff}:00:00'$${this.current_plan_id}$'${timeZoneDiff}:00:00'$${this.tradeQuery}$${this.teamQuery}$${this.shiftQuery}`;
    CloudScheduler.queryForLoad = sonucLoad;
    this.setState({
      query: CloudScheduler.queryForLoad,
      queryForLoad: sonucLoad,
    });
    this.context.setLoadAllowChange(true);
    this.setState({ hideFilterDialog: false });
  }
  expand = () => {
    var element = document.getElementById('expandable');
    if (this.state.status) {
      element?.classList.remove('layoutExpand');
      element?.classList.add('layoutCollapse');
      // this.setState({ currentIcon: <FaAngleDown size='14px' /> });
    } else {
      element?.classList.remove('layoutCollapse');
      element?.classList.add('layoutExpand');
      // this.setState({ currentIcon: <FaAngleUp size='14px' /> })
    }
    this.setState({
      status: !this.state.status,
      currentIcon: this.state.status ? (
        <FaAngleDown size='14px' />
      ) : (
        <FaAngleUp size='14px' />
      ),
      allowRender: true,
    });
  };
  dataBound = () => {
    // @ts-ignore
    if (this.isInitial) {
      // this.gantObj.fitToProject();
    }
    this.isInitial = false;
    // if (searchEle) {
    //   searchEle.ariaAutoComplete = 'off'; // turn autocomplete off
    // }
  };
  ganntFItHandler(date: Date) {
    var startDate = moment(
      new Date(this.cur_plan_start_date).setDate(
        new Date(this.cur_plan_start_date).getDate() - 7
      )
    ).format('yyy-MM-DD');
    var endDate = moment(
      new Date(this.cur_plan_start_date).setDate(
        new Date(this.cur_plan_start_date).getDate() + 14
      )
    ).format('yyy-MM-DD');
    this.setInitialParamters(startDate, endDate);
  }
  setHidePlanOrder = (val: boolean) => {
    this.setState({ hideDialogOrder: val });
  };
  render() {
    return (
      <div>
        <div
          className='header-cloud-scheduler-fixed'
          style={{
            marginRight: 30,
            marginTop: this.props.isSuperVisor ? 22 : 0,
          }}
        >
          <button
            style={{
              height: '40px',
              backgroundColor: 'transparent',
              border: 'none',
              zIndex: 1000,
            }}
            onClick={() => {
              this.sidebarobj?.toggle();
            }}
          >
            {this.state.isSidebarOpen ? (
              <BsChevronCompactRight />
            ) : (
              <BsChevronCompactLeft />
            )}
          </button>
          <FcSettings
            size={30}
            style={{ marginRight: 5 }}
            onClick={() => {
              this.setState({ settingsDialog: true });
            }}
          />
          <AiOutlineFilter
            size={30}
            style={{ marginRight: 5 }}
            onClick={() => {
              this.setState({ hideFilterDialog: true });
            }}
          />
          <div className='cloud-scheduler-input'>
            <DropDownListComponent
              placeholder='Event'
              ref={(el: DropDownListComponent) => (this.eventDropDown = el)}
              style={{ height: 25 }}
              dataSource={this.state.eventsData}
              fields={this.fieldEvent}
              value={0}
              onChange={this.onChangeEventPlan.bind(this, true)}
              dataBound={() => {}}
            />
          </div>
          <div className='cloud-scheduler-input'>
            <DropDownListComponent
              ref={(el: DropDownListComponent) => (this.planDropDown = el)}
              placeholder='Plan'
              style={{ height: 25 }}
              dataSource={this.state.planData}
              fields={this.fieldPlan}
              onChange={this.onChangePlan.bind(this, true)}
            />
          </div>
          {this.state.hideGant && this.props.isSuperVisor ? (
            <button
              style={{
                marginRight: '5px',
                marginLeft: 5,
                width: '70px',
                height: '35px',
              }}
              className='btn btn-primary p-3 rounded-xl'
              id='cloudSchedulerSavePoint'
              onClick={this.onLocked.bind(this)}
            >
              {this.state.current_plan_isLocked ? (
                <AiFillUnlock size={15} />
              ) : (
                <AiFillLock size={15} />
              )}
              {this.state.current_plan_isLocked ? 'UnLock' : 'Lock'}
            </button>
          ) : null}
        </div>
        <SidebarKPI
          sidebarOpen={(val: boolean) => this.setState({ isSidebarOpen: val })}
          refSide={(ref: SidebarComponent) => (this.sidebarobj = ref)}
          query={this.state.query}
        />
        <div className='main' onClick={this.expand.bind(this)}>
          <button
            className='expandableButton'
            disabled={this.state.expandableButton}
          >
            {this.state.currentIcon}
          </button>
        </div>
        <div id='expandable' className='layout'>
          <Load
            isLoad={false}
            queryForLoad={this.state.queryForLoad}
            handleDatePickerChange={this.handleOfLoadGridDateChange.bind(this)}
            fitInGant={this.ganntFItHandler.bind(this)}
            refreshToken={this.state.refreshToken}
          />
        </div>
        <div id='cloud-scheduler-main-content'>
          <div className='control-pane'>
            <div className='control-section'>
              <div
                style={{
                  width: '250px',
                  position: 'absolute',
                  top: '-25px',
                  left: '968px',
                  justifyContent: 'flex-end',
                  display: 'flex',
                  gap: '5px',
                }}
              />
              <div>
                <GanttComponent
                  id='cloud-scheduler-gantt'
                  dataSource={this.state.GantData}
                  ref={(gant: GanttComponent) => (this.gantObj = gant)}
                  dateFormat='dd/MM/yyyy HH:mm'
                  durationUnit='Hour'
                  actionComplete={this.actionCompletedElement.bind(this)}
                  actionBegin={this.actionBegin.bind(this)}
                  dataBound={this.dataBound.bind(this)}
                  treeColumnIndex={4}
                  contextMenuItems={this.contextMenuItems}
                  contextMenuOpen={this.contextMenuOpen.bind(this)}
                  contextMenuClick={this.contextMenuClick.bind(this)}
                  showColumnMenu={true}
                  taskType='FixedWork'
                  width={'100%'}
                  taskbarEditing={this.taskbarEditing.bind(this)}
                  allowFiltering={true}
                  selectionSettings={{
                    type: 'Multiple',
                    mode: 'Row',
                    enableToggle: true,
                  }}
                  allowSorting={true}
                  connectorLineBackground='red'
                  allowResizing={true}
                  workWeek={[
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday',
                    'Sunday',
                  ]}
                  toolbarClick={this.toolbarClick.bind(this)}
                  editDialogFields={this.editDialogFields}
                  projectStartDate={this.state.projectStartDate}
                  projectEndDate={this.state.projectEndDate}
                  allowRowDragAndDrop={false}
                  queryCellInfo={this.gantCellQuery.bind(this)}
                  rowSelected={this.rowSelected}
                  rowDeselected={this.rowDeselected}
                  taskFields={{
                    id: 'TaskID',
                    name: 'TaskName',
                    startDate: 'StartDate',
                    endDate: 'EndDate',
                    duration: 'Duration',
                    progress: 'Progress',
                    dependency: 'Predecessor',
                    child: 'subtasks',
                    notes: 'info',
                    resourceInfo: 'Resources',
                    segments: 'Segments',
                    work: 'Work',
                  }}
                  timelineSettings={this.timelineSettings}
                  labelSettings={this.labelSettings}
                  editSettings={
                    this.state.current_plan_isLocked
                      ? undefined
                      : this.editSettings
                  }
                  height={
                    this.state.status
                      ? 'calc(-130px + 70vh)'
                      : 'calc(-130px + 100vh)'
                  }
                  gridLines={'Both'}
                  toolbar={
                    this.props.isSuperVisor ? this.toolbarAdmin : this.toolbar
                  }
                  resourceFields={this.resourceFields}
                  resources={this.state.resourceData}
                  enableContextMenu={true}
                  filterSettings={{ type: 'Menu' }}
                  allowExcelExport={true}
                  allowPdfExport={true}
                  allowReordering={true}
                  highlightWeekends={true}
                  enableVirtualization={false}
                  splitterSettings={{
                    columnIndex: 2,
                    position: '60%',
                  }}
                  dayWorkingTime={this.state.dayWorkingTime}
                  timezone={Intl.DateTimeFormat().resolvedOptions().timeZone}
                >
                  <ColumnsDirective>
                    {columns.map((el: any) => {
                      return (
                        <ColumnDirective
                          key={el.field}
                          field={el.field}
                          headerText={el.headerText}
                          width={el.width}
                          visible={el.visible}
                          editType={el.editType}
                          edit={el.edit}
                          type={el.type}
                          format={el.format}
                          allowEditing={el.allowEditing}
                          displayAsCheckBox={el.displayAsCheckBox}
                          template={el.template}
                        />
                      );
                    })}
                  </ColumnsDirective>
                  <EditDialogFieldsDirective>
                    {editDialogFields.map((el) => {
                      return (
                        <EditDialogFieldDirective
                          key={el.type}
                          type={el.type as any}
                          headerText={el.headerText}
                        />
                      );
                    })}
                  </EditDialogFieldsDirective>
                  <Inject
                    services={[
                      Edit,
                      Selection,
                      Toolbar,
                      DayMarkers,
                      CriticalPath,
                      Resize,
                      ColumnChooser,
                      Filter,
                      ContextMenu,
                      ColumnMenu,
                      VirtualScroll,
                      ExcelExport,
                      PdfExport,
                      Sort,
                      Reorder,
                    ]}
                  />
                </GanttComponent>
              </div>
            </div>
          </div>
          {this.state.hideDeleteDialog ? (
            <GlobalDialog
              showDialog={this.state.hideDeleteDialog}
              setShowDialog={(val) => this.setState({ hideDeleteDialog: val })}
              header='Confirm Shift Assign'
              width={'222px'}
              hideDoneButton={true}
              buttons={this.buttonShiftAssignment}
            >
              <>
                <DropDownListComponent
                  dataSource={this.state.ShiftElementData}
                  placeholder='Shift'
                  fields={{ text: 'rosterCode', value: 'rosterId' }}
                  ref={(scope: DropDownListComponent) =>
                    (this.dropDownListObjectShiftElment = scope)
                  }
                  itemTemplate={
                    (this.itemTemplateShiftColor =
                      this.itemTemplateShiftColor.bind(this))
                  }
                />
              </>
            </GlobalDialog>
          ) : null}

          {this.state.hideAssignTeamDialog ? (
            <GlobalDialog
              showDialog={this.state.hideAssignTeamDialog}
              setShowDialog={(val) =>
                this.setState({ hideAssignTeamDialog: val })
              }
              header='Confirm Team Assign'
              width={'270px'}
              hideDoneButton={true}
              buttons={this.buttonTeamAssignment}
            >
              <>
                <GlobalDropDown
                  id='cloudscheduler-team'
                  placeHolder='Select a team'
                  key='cloudscheduler-team-key'
                  field={{ value: 'team_id', text: 'team_code' }}
                  refDD={(scope: DropDownListComponent) =>
                    (this.assignTeamDropDown = scope)
                  }
                  url='team'
                  value={this.assignTeamText}
                  floatLabelType='Never'
                />
              </>
            </GlobalDialog>
          ) : null}
          {this.state.hidePercentage ? (
            <GlobalDialog
              showDialog={this.state.hidePercentage}
              setShowDialog={(val) => this.setState({ hidePercentage: val })}
              header='Confirm Percentage'
              width={'222px'}
              hideDoneButton={true}
              buttons={this.buttonPercentage}
            >
              <NumericTextBoxComponent
                ref={(el: NumericTextBoxComponent) => (this.percentage = el)}
                format='n'
                value={0}
                min={0}
                max={100}
              />
            </GlobalDialog>
          ) : null}
          {this.state.hideSchedulerTimeDialog ? (
            <GlobalDialog
              showDialog={this.state.hideSchedulerTimeDialog}
              setShowDialog={(val) =>
                this.setState({ hideSchedulerTimeDialog: val })
              }
              header='Confirm Scheduler'
              width={'350px'}
              hideDoneButton={true}
              buttons={this.buttonScheduler}
            >
              <DateTimePickerComponent
                placeholder='Select a range'
                ref={(scope: DateTimePickerComponent) =>
                  (this.dateTimePicker = scope)
                }
              />
            </GlobalDialog>
          ) : null}
          {this.state.hideFilterDialog ? (
            <GlobalDialog
              showDialog={this.state.hideFilterDialog}
              setShowDialog={(val) => this.setState({ hideFilterDialog: val })}
              header='Apply Filter'
              width={'500px'}
              hideDoneButton={true}
              buttons={this.buttonFilter}
            >
              <div style={{ margin: '10px' }}>
                <GlobalMultiSelection
                  floatLabelType='Always'
                  field={{ text: 'team_code', value: 'team_id' }}
                  id='cloudscheduler-multiselection-team'
                  url='team'
                  placeHolder='Select Teams'
                  value={this.teamValues}
                  onChange={(val: any) => {
                    this.teamValues = val.target.value;
                    this.setState({ teamIds: this.teamValues });
                  }}
                  refDD={(ms: MultiSelectComponent) => (this.teamFMSCom = ms)}
                />
              </div>
              <div style={{ margin: '10px' }}>
                <GlobalMultiSelection
                  floatLabelType='Always'
                  field={{ text: 'trade_code', value: 'trade_id' }}
                  id='cloudscheduler-multiselection'
                  url={`trade/trade-codes-by-team?teamIds=${this.teamValues}`}
                  placeHolder='Select Trades'
                  value={this.tradeValues}
                  onChange={(val: any) => (this.tradeValues = val.target.value)}
                  refDD={(ms: MultiSelectComponent) =>
                    (this.multiselectForTradeObj = ms)
                  }
                />
              </div>
              <div style={{ margin: '10px' }}>
                <GlobalMultiSelection
                  floatLabelType='Always'
                  field={{ text: 'rosterCode', value: 'rosterCode' }}
                  id='cloudscheduler-multiselection-shift'
                  url='shift'
                  placeHolder='Select Shift'
                  value={this.shiftValues}
                  onChange={(val: any) => (this.shiftValues = val.target.value)}
                  refDD={(ms: MultiSelectComponent) => (this.shiftFMSCom = ms)}
                />
              </div>
            </GlobalDialog>
          ) : null}
          {this.state.settingsDialog ? (
            <GlobalDialog
              showDialog={this.state.settingsDialog}
              setShowDialog={(val) => this.setState({ settingsDialog: val })}
              header='Gantt Settings'
              width={'500px'}
              hideDoneButton={false}
              content={() => {
                return (
                  <GanttSettings
                    allowDragDrop={this.state.allowDragDrop}
                    setAllowDragDrop={(val) =>
                      this.setState({ allowDragDrop: val })
                    }
                    allowSeg={this.state.allowSeg}
                    gantObj={this.gantObj}
                    dayWorkingTime={this.state.dayWorkingTime}
                    setAllowSeg={(val) => this.setState({ allowSeg: val })}
                    setDayWorkingTime={(val) =>
                      this.setState({ dayWorkingTime: val })
                    }
                  />
                );
              }}
            ></GlobalDialog>
          ) : null}
          {this.state.currentDialogSettings.show ? (
            <DialogComponent
              isModal={true}
              id='defaultDialogAddTrades'
              showCloseIcon={true}
              visible={this.state.currentDialogSettings.show}
              width={this.state.currentDialogSettings.width}
              height={this.state.currentDialogSettings.height}
              header='Confirm'
              buttons={[
                {
                  click: () => {
                    if (this.state.currentDialogSettings.type === 'exeption') {
                      this.approveSendBack();
                    } else if (
                      this.state.currentDialogSettings.type === 'done'
                    ) {
                      this.setProgressGanttRecords();
                    } else {
                      this.applyConfirm();
                    }
                  },
                  buttonModel: {
                    content: this.state.currentDialogSettings.firstButtonText,
                    isPrimary: true,
                  },
                },
                {
                  click: () => {
                    this.setState({
                      currentDialogSettings: {
                        ...this.state.currentDialogSettings,
                        show: false,
                      },
                    });
                  },
                  buttonModel: {
                    content: this.state.currentDialogSettings.seccondButtonText,
                  },
                },
              ]}
              close={() => {
                this.setState({
                  currentDialogSettings: {
                    ...this.state.currentDialogSettings,
                    show: false,
                  },
                });
              }}
              content={this.state.currentDialogSettings.content}
            ></DialogComponent>
          ) : null}
        </div>
        {this.state.hideDialogOrder ? (
          <GlobalPlannedOrderGrid
            hideDialogOrder={this.state.hideDialogOrder}
            setHideDialogOrder={this.setHidePlanOrder}
            getPlanOrder={this.buildQuery.bind(this)}
            plan_id={this.current_plan_id}
          />
        ) : null}
      </div>
    );
  }
}

function withMyHook(CloudScheduler: any) {
  return function WrappedComponent(props: any) {
    const dispatch = useDispatch();
    return <CloudScheduler {...props} dispatch={dispatch} />;
  };
}
export default withMyHook(CloudScheduler);
